/*
 * Shared HTTP-method helpers for the endpoint (Postman) viewport — the op-list
 * badges and the builder bar read from the SAME source so a method's colour never
 * drifts between the two panes. `detail` is the SymbolRow's "METHOD /path" spec
 * (e.g. "GET /sensors/{id}"); a REST op carries it, a PLC symbol never does.
 */

/** Split a `detail` spec into its method + URL. "GET /x" → {method:"GET", url:"/x"};
 *  a bare "/x" (or empty) defaults to GET. Method is upper-cased. */
export function parseSpec(detail: string): { method: string; url: string } {
  const s = (detail ?? '').trim();
  if (!s) return { method: 'GET', url: '' };
  const i = s.indexOf(' ');
  if (i <= 0) return { method: 'GET', url: s.startsWith('/') ? s : `/${s}` };
  return { method: s.slice(0, i).toUpperCase(), url: s.slice(i + 1).trim() };
}

// method → [foreground token, low-alpha background]. GET is green (safe/read),
// mutating verbs get warmer/redder — the Postman convention.
const METHOD_COLORS: Record<string, [string, string]> = {
  GET: ['var(--green)', 'color-mix(in srgb, var(--green) 14%, transparent)'],
  POST: ['var(--amber)', 'color-mix(in srgb, var(--amber) 14%, transparent)'],
  PUT: ['var(--blue)', 'color-mix(in srgb, var(--blue) 14%, transparent)'],
  PATCH: ['var(--purple)', 'color-mix(in srgb, var(--purple) 14%, transparent)'],
  DELETE: ['var(--red)', 'color-mix(in srgb, var(--red) 14%, transparent)'],
};

export function methodColor(method: string): [string, string] {
  return METHOD_COLORS[method.toUpperCase()] ?? ['var(--text-secondary)', 'var(--hover-bg)'];
}
